import {AvailableMarketedYearsValueObject} from './AvailableMarketedYearsValueObject.js'
import {BodyTypeParamsValueObject} from './BodyTypeParamsValueObject.js'
import {BodyTypesListValueObject} from './BodyTypesListValueObject.js'
import {BodyTypeValueObject} from './BodyTypeValueObject.js'
import {BrandModelInfoValueObject} from './BrandModelInfoValueObject.js'
import {CarouselInfoValueObject} from './CarouselInfoValueObject.js'
import {CarouselsInfoValueObject} from './CarouselsInfoValueObject.js'
import {DescriptionItemValueObject} from './DescriptionItemValueObject.js'
import {ElectricFeaturesValueObject} from './ElectricFeaturesValueObject.js'
import {EquipmentSectionValueObject} from './EquipmentSectionValueObject.js'
import {EquipmentValueObject} from './EquipmentValueObject.js'
import {FaqsValueObject} from './FaqsValueObject.js'
import {FaqValueObject} from './FaqValueObject.js'
import {GroupedVersionSpecificationsValueObject} from './GroupedVersionSpecificationsValueObject.js'
import {ImagesListValueObject} from './ImagesListValueObject.js'
import {ImageValueObject} from './ImageValueObject.js'
import {InfoVehicleValueObject} from './InfoVehicleValueObject.js'
import {LatestModelValueObject} from './LatestModelValueObject.js'
import {MakesListValueObject} from './MakesListValueObject.js'
import {MarketedMakesValueObject} from './MarketedMakesValueObject.js'
import {MarketedVersionsListValueObject} from './MarketedVersionsListValueObject.js'
import {MarketedVersionValueObject} from './MarketedVersionValueObject.js'
import {MarketedYearValueObject} from './MarketedYearValueObject.js'
import {ModelDetailContentValueObject} from './ModelDetailContentValueObject.js'
import {ModelInfoValueObject} from './ModelInfoValueObject.js'
import {ModelsGroupedByBodyTypeDoorsValueObject} from './ModelsGroupedByBodyTypeDoorsValueObject.js'
import {ModelsListValueObject} from './ModelsListValueObject.js'
import {ModelVersionsValueObject} from './ModelVersionsValueObject.js'
import {OfferPriceValueObject} from './OfferPriceValueObject.js'
import {RelatedVehiclesListValueObject} from './RelatedVehiclesListValueObject.js'
import {RelatedVehicleValueObject} from './RelatedVehicleValueObject.js'
import {SearchCodeValueObject} from './SearchCodeValueObject.js'
import {SearchVehiclesRequestValueObject} from './SearchVehiclesRequestValueObject.js'
import {SearchVehiclesResultsValueObject} from './SearchVehiclesResultsValueObject.js'
import {SpecsListValueObject} from './SpecsListValueObject.js'
import {SpecsValueObject} from './SpecsValueObject.js'
import {SubscriptionModelsListValueObject} from './SubscriptionModelsListValueObject.js'
import {SubscriptionModelValueObject} from './SubscriptionModelValueObject.js'
import {VehicleCertificationFeaturesListValueObject} from './VehicleCertificationFeaturesListValueObject.js'
import {VehicleCertificationFeatureValueObject} from './VehicleCertificationFeatureValueObject.js'
import {VehicleCertificationValueObject} from './VehicleCertificationValueObject.js'
import {VehicleHistoryValueObject} from './VehicleHistoryValueObject.js'
import {VehicleInfoValueObject} from './VehicleInfoValueObject.js'
import {VehicleInsightsValueObject} from './VehicleInsightsValueObject.js'
import {VehicleOffersListValueObject} from './VehicleOffersListValueObject.js'
import {VehicleOfferValueObject} from './VehicleOfferValueObject.js'
import {VehiclesListValueObject} from './VehiclesListValueObject.js'
import {VersionInfoValueObject} from './VersionInfoValueObject.js'
import {VersionSpecificationsValueObject} from './VersionSpecificationsValueObject.js'

export default class VehiclesValueObjectsFactory {
  static brandModelInfoValueObject = ({name, description, imageUrl}) =>
    new BrandModelInfoValueObject({name, description, imageUrl})

  static infoVehicleValueObjectFactory = data => new InfoVehicleValueObject(data)

  static marketedMakesValueObject = ({makesList}) => new MarketedMakesValueObject({makesList})

  static modelsGroupedByBodyTypeDoorsValueObject = ({modelsList}) =>
    new ModelsGroupedByBodyTypeDoorsValueObject({modelsList})

  static latestModelValueObject = ({financedOfferPrice, image, make, makeId, model, modelId, offerPrice, price, url}) =>
    new LatestModelValueObject({
      financedOfferPrice,
      image,
      make,
      makeId,
      model,
      modelId,
      offerPrice,
      price,
      url
    })

  static modelsListValueObject = ({items}) => new ModelsListValueObject({items})

  static makesListValueObject = ({items}) => new MakesListValueObject({items})

  static searchCodeValueObject = ({searchCode}) => new SearchCodeValueObject({searchCode})

  static faqValueObjectFactory = ({question, answer}) => new FaqValueObject({question, answer})

  static faqsValueObjectFactory = ({items}) => new FaqsValueObject({items})

  static bodyTypeParamsValueObject = ({bodyType, doors, year}) => new BodyTypeParamsValueObject({bodyType, doors, year})

  static modelDetailContentValueObject = ({body, cons, description, faqs, photos, pros, title, seoFaqs}) =>
    new ModelDetailContentValueObject({
      body,
      cons,
      description,
      faqs,
      photos,
      pros,
      title,
      seoFaqs
    })

  static vehicleInsightsValueObject = ({
    bodyType,
    make,
    countVersions,
    countDoorsOptions,
    minPrice,
    maxPrice,
    minLength,
    minWidth,
    minHeight,
    maxLength,
    maxWidth,
    maxHeight,
    minLuggageCapacity,
    maxLuggageCapacity,
    fuelTypes,
    maxFuelType,
    minFuelType,
    minHp,
    maxHp,
    minAcceleration,
    maxAcceleration
  }) =>
    new VehicleInsightsValueObject({
      bodyType,
      make,
      countVersions,
      countDoorsOptions,
      minPrice,
      maxPrice,
      minLength,
      minWidth,
      minHeight,
      maxLength,
      maxWidth,
      maxHeight,
      minLuggageCapacity,
      maxLuggageCapacity,
      fuelTypes,
      maxFuelType,
      minFuelType,
      minHp,
      maxHp,
      minAcceleration,
      maxAcceleration
    })

  static modelInfoValueObject = ({modelInfo}) => new ModelInfoValueObject({modelInfo})

  static modelVersionsValueObjectFactory = ({
    competitors,
    items,
    lowerFinancedOfferPrice,
    lowerSpotOfferPrice,
    lowerVersionPrice,
    mainImage,
    images,
    make,
    model,
    vehicleInsights
  }) => {
    return new ModelVersionsValueObject({
      competitors,
      items,
      lowerFinancedOfferPrice,
      lowerSpotOfferPrice,
      lowerVersionPrice,
      mainImage,
      images,
      make,
      model,
      vehicleInsights
    })
  }

  static offerPriceValueObject = ({endDate, financedPrice, label, legalConditions, spotPrice}) =>
    new OfferPriceValueObject({
      endDate,
      financedPrice,
      label,
      legalConditions,
      spotPrice
    })

  static vehicleOfferValueObject = ({offerPrice, vehicle}) => new VehicleOfferValueObject({offerPrice, vehicle})

  static bodyTypesListValueObject = ({items}) => new BodyTypesListValueObject({items})

  static bodyTypeValueObject = ({bodyType, doors, url, isSelected}) =>
    new BodyTypeValueObject({bodyType, doors, url, isSelected})

  static vehiclesListValueObject = ({items}) => new VehiclesListValueObject({items})

  static vehicleOffersListValueObject = ({items}) => new VehicleOffersListValueObject({items})

  static relatedVehiclesListValueObject = ({items}) => new RelatedVehiclesListValueObject({items})

  static relatedVehicleValueObject = ({doors, imageUrl, make, makeId, model, modelId, url}) =>
    new RelatedVehicleValueObject({
      doors,
      imageUrl,
      make,
      makeId,
      model,
      modelId,
      url
    })

  static imagesListValueObject = ({items}) => new ImagesListValueObject({items})

  static imageValueObject = ({src}) => new ImageValueObject({src})

  static versionInfoValueObject = ({versionInfo}) => new VersionInfoValueObject({versionInfo})

  static vehicleInfoValueObject = ({vehicleInfo}) => new VehicleInfoValueObject({vehicleInfo})

  static equipmentValueObject = ({standard, optional}) => new EquipmentValueObject({standard, optional})

  static equipmentSectionValueObject = ({title, descriptions}) => new EquipmentSectionValueObject({title, descriptions})

  static marketedVersionsListValueObject = ({items}) => new MarketedVersionsListValueObject({items})

  static carouselInfoValueObject = ({title, items}) => new CarouselInfoValueObject({title, items})

  static carouselsInfoValueObject = ({carousels}) => new CarouselsInfoValueObject({carousels})

  static marketedVersionValueObject = ({price, url, initDate, endDate}) =>
    new MarketedVersionValueObject({price, url, initDate, endDate})

  static groupedVersionSpecificationsValueObject = ({body, consumption, cycle, engine}) =>
    new GroupedVersionSpecificationsValueObject({
      body,
      consumption,
      cycle,
      engine
    })

  static versionSpecificationsValueObject = ({
    acceleration,
    autonomy,
    axisDistance,
    barsDiameter,
    batteryType,
    bodyType,
    bore,
    brakeCalipers,
    chargingTime,
    chassis,
    clutch,
    configuration,
    consumptionAverage,
    consumptionExtraUrban,
    consumptionUrban,
    cubicCapacity,
    cycle,
    cylinders,
    cylindersDisposition,
    cylinderValves,
    distribution,
    doors,
    emissions,
    electricFeatures,
    forkAngle,
    frontBrake,
    frontBrakeDiameter,
    frontSuspension,
    frontSuspensionSetting,
    frontTyre,
    frontWheelTravel,
    fuelTankCapacity,
    fuelType,
    gearBox,
    gears,
    height,
    hp,
    hpRpm,
    kw,
    length,
    luggageCapacity,
    make,
    manufacturerPrice,
    model,
    movementWeight,
    pistons,
    powerElectric,
    rearBrake,
    rearBrakeDiameter,
    rearSuspension,
    rearSuspensionSetting,
    rearTyre,
    rearWheelTravel,
    refrigeration,
    seatHeight,
    seats,
    starterSystem,
    stroke,
    supply,
    swingingArm,
    topSpeed,
    torque,
    torqueRpm,
    traction,
    trail,
    transmissionType,
    version,
    weight,
    width
  }) =>
    new VersionSpecificationsValueObject({
      acceleration,
      autonomy,
      axisDistance,
      barsDiameter,
      batteryType,
      bodyType,
      bore,
      brakeCalipers,
      chargingTime,
      chassis,
      clutch,
      configuration,
      consumptionAverage,
      consumptionExtraUrban,
      consumptionUrban,
      cubicCapacity,
      cycle,
      cylinders,
      cylindersDisposition,
      cylinderValves,
      distribution,
      doors,
      emissions,
      electricFeatures,
      forkAngle,
      frontBrake,
      frontBrakeDiameter,
      frontSuspension,
      frontSuspensionSetting,
      frontTyre,
      frontWheelTravel,
      fuelTankCapacity,
      fuelType,
      gearBox,
      gears,
      height,
      hp,
      hpRpm,
      kw,
      length,
      luggageCapacity,
      make,
      manufacturerPrice,
      model,
      movementWeight,
      pistons,
      powerElectric,
      rearBrake,
      rearBrakeDiameter,
      rearSuspension,
      rearSuspensionSetting,
      rearTyre,
      rearWheelTravel,
      refrigeration,
      seatHeight,
      seats,
      starterSystem,
      stroke,
      supply,
      swingingArm,
      topSpeed,
      torque,
      torqueRpm,
      traction,
      trail,
      transmissionType,
      version,
      weight,
      width
    })

  static availableMarketedYearsValueObject = ({items}) => new AvailableMarketedYearsValueObject({items})

  static marketedYearValueObject = ({title, url, isSelected}) => new MarketedYearValueObject({title, url, isSelected})

  static descriptionItemValueObject = ({value, price}) =>
    new DescriptionItemValueObject(price === undefined ? {value} : {value, price})

  static electricFeaturesValueObject = (
    batteryCapacity,
    chargingConnector,
    consumptionAverageElectricWltp,
    electricChargingTime,
    fastChargingTime,
    fuelConsumptionCombined,
    fuelConsumptionStandard,
    maxPower,
    motorType,
    onboardCharger,
    range
  ) =>
    new ElectricFeaturesValueObject(
      batteryCapacity,

      chargingConnector,
      consumptionAverageElectricWltp,
      electricChargingTime,
      fastChargingTime,
      fuelConsumptionCombined,
      fuelConsumptionStandard,
      maxPower,
      motorType,
      onboardCharger,
      range
    )

  static specsListValueObject = ({items}) => new SpecsListValueObject({items})

  static specsValueObject = ({value, text, customText, images}) =>
    new SpecsValueObject({value, text, ...(customText && {customText}), ...(images && {images})})

  static searchVehiclesRequestValueObject = ({filters, pagination, sort}) =>
    new SearchVehiclesRequestValueObject({filters, pagination, sort})

  static searchVehiclesResultsValueObject = ({appliedFilters, items, meta}) =>
    new SearchVehiclesResultsValueObject({appliedFilters, items, meta})

  static subscriptionModelValueObject = ({make, model}) => new SubscriptionModelValueObject({make, model})

  static subscriptionModelsListValueObject = ({items}) => new SubscriptionModelsListValueObject({items})

  static vehicleHistoryValueObject = ({hasReport, reportUrl, verifiedData}) =>
    new VehicleHistoryValueObject({hasReport, reportUrl, verifiedData})

  static vehicleCertificationFeatureValueObject = ({description, iconUrl, title}) =>
    new VehicleCertificationFeatureValueObject({
      description,
      iconUrl,
      title
    })

  static vehicleCertificationFeaturesListValueObject = ({items}) =>
    new VehicleCertificationFeaturesListValueObject({items})

  static vehicleCertificationValueObject = ({certificatedProgramId, features, logoUrl, make}) =>
    new VehicleCertificationValueObject({
      certificatedProgramId,
      features,
      logoUrl,
      make
    })
}
